/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type IntlService from 'ember-intl/services/intl';
import type EcommerceProduct from 'embercom/models/ecommerce-product';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';

interface Args {
  activeContent: EcommerceProduct;
  editActiveContent: () => void;
  showSidePanel: boolean;
  toggleSidePanel: () => void;
}

export default class Header extends Component<Args> {
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare knowledgeHubService: KnowledgeHubService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::EcommerceProduct::View::Header': typeof Header;
    'knowledge-hub/content-editor/ecommerce-product/view/header': typeof Header;
  }
}
